var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQStudyInactiveGift = function SvgQStudyInactiveGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.447,
    height: 16.357,
    x: 3.276,
    y: 4.643,
    fill: "#C9CCDE",
    rx: 1.636
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E7F4",
    d: "M10.364 4.643h3.271V21h-3.271zM6.548 2.105c0-.366.352-.628.702-.523L12 3.008l4.75-1.426a.545.545 0 0 1 .702.523v2.538H6.548z"
  })));
};
export { SvgQStudyInactiveGift as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIj4KICA8cmVjdCB4PSIzLjI3NjM3IiB5PSI0LjY0MzE5IiB3aWR0aD0iMTcuNDQ3MyIgaGVpZ2h0PSIxNi4zNTY4IiByeD0iMS42MzU2OCIgZmlsbD0iI0M5Q0NERSIvPgogIDxyZWN0IHg9IjEwLjM2NDMiIHk9IjQuNjQzMTkiIHdpZHRoPSIzLjI3MTM2IiBoZWlnaHQ9IjE2LjM1NjgiIGZpbGw9IiNFNEU3RjQiLz4KICA8cGF0aCBkPSJNNi41NDc4NSAyLjEwNDYzQzYuNTQ3ODUgMS43Mzk0IDYuODk5OTIgMS40Nzc0NSA3LjI0OTc1IDEuNTgyNEwxMi4wMDAxIDMuMDA3NTFMMTYuNzUwNSAxLjU4MjRDMTcuMTAwMyAxLjQ3NzQ1IDE3LjQ1MjQgMS43Mzk0IDE3LjQ1MjQgMi4xMDQ2M1Y0LjY0MzE5SDYuNTQ3ODVWMi4xMDQ2M1oiIGZpbGw9IiNFNEU3RjQiLz4KPC9zdmc+Cg==";